import { FlightDto, TrafficType } from 'app/model/CORE';
import { SOL49_MAP_FLIGHTS_DATA_REQUEST_DTO_CLAZZ_VALUE } from 'app/model/SOL49';
import { ServiceFactory } from 'app/service/ServiceFactory';
import { notification } from 'antd';

import AppContext from '../context/AppContext';

export class FlightEnricher {
    public async enrichAsync(flights: FlightDto[], dashboardDataVersion: number) {
        // NOTE(bjarne): This code somewhat mimics what happens in NetworkMonitoringMap.
        // We refetch the flights because the ones we get passed in don't have their airspace points populated.
        const reply = await ServiceFactory.sol49Service().getMapFlightsData({
            clazz: SOL49_MAP_FLIGHTS_DATA_REQUEST_DTO_CLAZZ_VALUE,
            dataset: AppContext.getDataset(),
            flights: flights.map(flight => flight.flightId),
            retrieveVpdFlightData: true,
            flightProfileTrafficType: TrafficType.LOAD,
            retrieveCurrentFlightAirspaceCrossingsWithLoad: true,
            monitoringDataVersion: dashboardDataVersion,
        });

        if (reply.error) {
            notification.error({ message: 'Error', description: reply.error.message, duration: 0 });
            return flights;
        }

        return reply.data?.flights;
    }
}
